<template>
  <div>
    <!-- Filters -->
    <div class="tags has-addons" v-if='Object.keys(this.selected.filters).length > 0'>
      <span class="tag is-grey-light" v-tooltip='"Filtro del tablero"'>{{getFilterGroup(this.selected.filters)}}</span>
      <span class="tag is-blue">{{getFilterSubGroup(this.selected.filters)}}</span>
    </div>
    <!-- Graph Mytho -->
    <div class='container box'>
      <div class="has-text-centered" v-if="this.summaryTotal.empty">
        <h2 class="rango0" style="margin: 5px; padding: 15px; border-radius: 5px" v-if="Object.keys(this.selected.filters).length > 0">
          Dependencia <strong>{{Object.values(this.selected.filters)[0][0]}}</strong> no cumple con más de 4 empleados
        </h2>
      </div>
      <div class='is-fullwidth'>
        <div class='is-flex' style='justify-content: center'>
          <i v-on:click="changeShowMoreMytho"
             data-tooltip='Ver más'
             class="material-icons has-text-dark"
             style="cursor: pointer; padding-right: 10px">
            {{showMoreMytho ? 'remove_circle_outline' : 'add_circle_outline' }}
          </i>
          <h1 class="has-text-dark has-text-weight-bold has-text-centered">MYTHO  <span>{{ summaryTotal.empty ? '- Sin Datos' : ''}}</span></h1>
        </div>
        <br>
      </div>
      <div class='columns'>
        <div class="column" v-if='summaryTotal'>
          <y-graph :datagraph="datagrafica" :cambio="cambio"></y-graph>
        </div>
        <div class="column" v-if='summaryTotal.total'>
          <div class='is-flex' style='justify-content: space-between; margin-bottom: 20px'>
            <span style="margin-left: 10px; color: #510087;">Cuadrante</span>
            <table v-if='false' class="is-flex is-fullwidth">
              <tr class="bg-baja" style='border-radius: 50px 0px 0px 50px;' v-tooltip.bottom="'Brecha menor a 5'">
                <td class="p-2">Baja</td>
              </tr>
              <tr class="bg-media" v-tooltip.bottom="'Brecha entre 5 y 10'">
                <td class="p-2">Media</td>
              </tr>
              <tr class="bg-alta" v-tooltip.bottom="'Brecha entre 10 y 20'">
                <td class="p-2">Alta</td>
              </tr>
              <tr class="bg-muyAlta" style='border-radius: 0px 50px 50px 0px;' v-tooltip.bottom="'Brecha mayor o igual a 20'">
                <td class="p-2">Muy alta</td>
              </tr>
            </table>
            <span style="margin-right: 40px; color: #510087;">Brecha</span>
          </div>
          <div v-for='(v,k) in names' :key='k'>
            <b-graph :data-graph="createdGraphBullet(v.name, v.hoy, v.futuro, v.color)" :cambio="cambio" ></b-graph>
          </div>
        </div>
      </div>
    </div>

    <!-- Dimensions -->
    <transition name='fade'>
      <div class='container box' v-if='showMoreMytho'>
        <h2 class="rango0 has-text-centered" style="margin: 5px; padding: 15px" v-if="Object.keys(summaryTotal.dimensiones).length === 0">
          Sin Datos para mostrar
        </h2>
        <div style='column-count: 2; column-gap: 12px;' v-if='summaryTotal'>
          <div v-for='(v,k) in summaryTotal.dimensiones' :key='k' style='margin-bottom: 20px'>
            <h1 class="has-text-dark has-text-weight-bold has-text-centered">{{dimensiones.names[k]}}  <span>{{ summaryTotal.empty ? '- Sin Datos' : ''}}</span></h1>
            <br>
            <y-graph :datagraph="graficaDimen(v)" :cambio="cambio"></y-graph>
          </div>
        </div>
      </div>
    </transition>

    <!-- Graph's frases and Entrevistas -->
    <transition name='fade'>
      <div v-if='!Object.keys(this.selected.filters).length' class="container box">
      <div class="columns">
        <div class="column" v-if='proceso'>
          <h1 class="has-text-dark has-text-weight-bold has-text-centered">Frases <span>{{ proceso.manuales ? '' : '- Sin Datos' }}</span></h1>
          <br>
          <y-graph :datagraph="datagraficafrases" :cambio="cambio"></y-graph>
        </div>
        <div class="column" v-if='proceso'>
          <h1 class="has-text-dark has-text-weight-bold has-text-centered">Entrevistas <span>{{ proceso.manualesEn ? '' : '- Sin Datos' }}</span></h1>
          <br>
          <y-graph :datagraph="datagraficaEntre" :cambio="cambio"></y-graph>
        </div>
      </div>
    </div>
    </transition>
    <!-- Table -->
    <div v-if='!this.$route.params.id'>
      <table-groups-result ref='tableCult' :datos='this.summary' @setFilterTable='setFilterTable'></table-groups-result>
    </div>

  </div>
</template>

<script>
import apiServices from "../../services/yungol-services";
import yGraph from "@/components/dashboard/Graphcultura.vue";
import bGraph from '@/components/dashboard/GraphBullet.vue';
import tableGroupsResult from './tableGroupsResult.vue'
import {mapState} from 'vuex'

const filterItems = (query, data, sort) => {
  let group = sort[0]
  let type = sort[1]

  let filter = data.filter(function (el) {
    let texto = el.nombre
    el.cambio === 0 ? el.cambio = 1 : el.cambio = 0
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1 && texto !== "null") {
      return el;
    }
  });

  if (sort.length > 0) {
    if (type === 'down') {
      return filter.sort(function (a, b) {
        return a[group].p - b[group].p
      })
    } else {
      return filter.sort(function (a, b) {
        return a[group].p - b[group].p
      }).reverse()
    }
  } else {
    return filter
  }
};

export default {
  data() {
    return {
      apex: {
        series: [
          {
            name: 'Es',
            data: [
              {
                x: 'Datos',
                y: 12,
                goals: [
                  {
                    name: 'Deberia ser',
                    value: 14,
                    strokeWidth: 2,
                    strokeDashArray: 2,
                    strokeColor: '#775DD0'
                  }
                ]
              },
            ]
          }
        ],
        options: {
          chart: {
            width: '100%',
            height: '100%',
            redrawOnParentResize: true,
            redrawOnWindowResize: false,
            type: 'bar',
            toolbar: {
              show: false,
            },
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              colors: {
                backgroundBarColors: ['#f9f8f8'],
              },
            },
          },
          colors: ['#d9d2e9'],
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#242732'],
              fontSize: '16px',
            },
            formatter: (val) => val,
          },
          tooltip: {
            enabled: false,
          },
          grid: {
            show: false,
          },
          xaxis: {
            show: false,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          states: {
            hover: {
              filter: {
                type: 'none',
              },
            },
          },
          yaxis: {
            max: 100,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        type: 'bar',
      },
      search: "",
      summary: [],
      selected: {
        grupo: "",
        subgrupos: [],
        filters: {},
      },
      filters: {},
      filterTable: '',
      sortColumnTable: [],
      cambio: 0,
      valMayor: 0,
      datagrafica: {},
      datagraficafrases: {},
      datagraficaEntre: {},
      showMoreMytho: false,
      dimensiones: {
        names : {
          cd: "Características dominantes",
          lo: "Liderazgo organizacional",
          ap: "Administración del personal",
          une: "Los que nos une",
          ee: "Énfasis estratégico",
          ce: "Criterios de éxito"
        },
        ClanM_hoy: {
          name: '',
          list: ['ClCd', 'ClLo', 'ClAp', 'ClUne', 'ClEe', 'ClCe']
        },
        Adhocraciam_hoy: {
          name: '',
          list: ['AdCd', 'AdLo', 'AdAp', 'AdUne', 'AdEe', 'AdCe']
        },
        Jerarquicam_hoy: {
          name: '',
          list: ['JeCd', 'JeLo', 'JeAp', 'JeUne', 'JeEe', 'JeCe']
        },
        Mercadodm_hoy: {
          name: '',
          list: ['MeCd', 'MeLo', 'MeAp', 'MeUne', 'MeEe', 'MeCe']
        },
        ClanM_futuro: {
          nane: '',
          list: ['ClCd2', 'ClLo2', 'ClAp2', 'ClUne2', 'ClEe2', 'ClCe2']
        },
        Adhocraciam_futuro: {
          name: '',
          list: ['AdCd2', 'AdLo2', 'AdAp2', 'AdUne2', 'AdEe2', 'AdCe2']
        },
        Jerarquicam_futuro: {
          name: '',
          list: ['JeCd2', 'JeLo2', 'JeAp2', 'JeUne2', 'JeEe2', 'JeCe2']
        },
        Mercadodm_futuro: {
          name: '',
          list: ['MeCd2', 'MeLo2', 'MeAp2', 'MeUne2', 'MeEe2', 'MeCe2']
        }
      },
      names: [
        {'name': 'Adhocrática', hoy: "Adhocraciam_hoy", futuro: 'Adhocraciam_futuro', color: '#c889aa'},
        {'name': 'Mercado', hoy: "Mercadodm_hoy", futuro: 'Mercadodm_futuro', color: '#e8913a'},
        {'name': 'Jerárquica', hoy: "Jerarquicam_hoy", futuro: 'Jerarquicam_futuro', color: '#674ea8'},
        {'name': 'Clan', hoy: "ClanM_hoy", futuro: 'ClanM_futuro', color: '#3b79d8'}
      ],
      colors: [
        {'Adhocratica': '#c889aa'},
        {'Mercado':'#e8913a'},
        {'Jerarquica':'#674ea8'},
        {'Clan':'#3b79d8'}
      ],
      rangos: {
        baja: '#225ea8',
        media: '#4cc488',
        alta: '#fcdd82',
        muyAlta: '#fc8c82'
      },
    }
  },
  props: {
    proceso: {
      type: Object,
    },
    summaryTotal: {
      type: Object
    }
  },
  computed: {
    ...mapState(["idtoken"]),
    filteredItems: function () {
      let data = this.filterTable.length === 0 ? this.summary : this.summary.filter((el) => el.grupo === this.filterTable)
      return filterItems(this.search, data, this.sortColumnTable);
    },
  },
  beforeMount() {
    if (this.$route.params.id){
      if(this.proceso.filter){
        this.selected.filters = this.proceso.filter
      }
    }
  },
  methods: {
    // Graphics
    graficar(data) {
      const dataparagrafica = {
        typeGraphic: "radar",
        options: {
          datasetFill: false,
          spanGaps: true,
          legend: {
            position: "top",
            labels: {
              "fontSize": 10,
            },
            display: true
          },
          scale: {
            ticks: {
              beginAtZero: true,
              fontColor: "#000000",
              /* backdropColor: 'white', */
              circular: true,
              min: 0,
              max: 100,
              stepSize: 25,
              z: 1
            },
            pointLabels: {
              fontSize: 13,
              fontColor: ["#bdbbbd","#c889aa","#bdbbbd","#e8913a","#bdbbbd","#674ea8","#bdbbbd","#3b79d8"],
            }
          },
          layout: {
            padding: 0,
            margin: 0
          },
          responsive: true,
          maintainAspectRatio: true
        },
        colors: ["#36b8ba", "#510087"],
        datasetOverride: [],
        series: ["ES", "DEBERÍA SER"],
        labels: ["Flexibilidad", "Adhocrática", "Foco externo", "Mercado", "Consistencia", "Jerárquica", "Foco interno", "Clan"],
        data: [[null, 50, null, 52, null, 54, null, 56], [null, 60, null, 63, null, 66, null, 69],]
      }
      /* Datos hoy */
      dataparagrafica.data[0][1] = data.Adhocraciam_hoy.p;
      dataparagrafica.data[0][3] = data.Mercadodm_hoy.p;
      dataparagrafica.data[0][5] = data.Jerarquicam_hoy.p;
      dataparagrafica.data[0][7] = data.ClanM_hoy.p;

      /* Datos futuro */
      dataparagrafica.data[1][1] = data.Adhocraciam_futuro.p;
      dataparagrafica.data[1][3] = data.Mercadodm_futuro.p;
      dataparagrafica.data[1][5] = data.Jerarquicam_futuro.p;
      dataparagrafica.data[1][7] = data.ClanM_futuro.p;

      this.datagrafica = dataparagrafica;
      this.cambio === 0 ? this.cambio = 1 : this.cambio = 0
    },
    graficaFrases(){
      let proceso = this.proceso.manuales
      let data

      if (proceso){
        data ={
          /* Datos hoy */
          Adhocraciam_hoy: {p: parseFloat(proceso.adhocraticaes)},
          Jerarquicam_hoy: {p: parseFloat(proceso.jerarquicaes)},
          Mercadodm_hoy: {p: parseFloat(proceso.mercadoes)},
          ClanM_hoy: {p: parseFloat(proceso.clanes)},
          /* Datos futuro */
          Adhocraciam_futuro: {p: parseFloat(proceso.adhocraticads)},
          Jerarquicam_futuro: {p: parseFloat(proceso.jerarquicads)},
          Mercadodm_futuro: {p: parseFloat(proceso.mercadods)},
          ClanM_futuro: {p: parseFloat(proceso.clands)},
        }
      }else{
        data = {
          /* Datos hoy */
          Adhocraciam_hoy: {p: 0},
          Jerarquicam_hoy: {p: 0},
          Mercadodm_hoy: {p: 0},
          ClanM_hoy: {p: 0},
          /* Datos futuro */
          Adhocraciam_futuro: {p: 0},
          Jerarquicam_futuro: {p: 0},
          Mercadodm_futuro: {p: 0},
          ClanM_futuro: {p: 0},
        }
      }

      const dataparagrafica = {
        typeGraphic: "radar",
        options: {
          datasetFill: false,
          spanGaps: true,
          legend: {
            position: "top",
            labels: {
              "fontSize": 10,
            },
            display: true
          },
          scale: {
            ticks: {
              beginAtZero: true,
              fontColor: "#000000",
              /* backdropColor: 'white', */
              circular: true,
              min: 0,
              max: 100,
              stepSize: 25,
              z: 1
            },
            pointLabels: {
              fontSize: 13,
              fontColor: ["#bdbbbd","#c889aa","#bdbbbd","#e8913a","#bdbbbd","#674ea8","#bdbbbd","#3b79d8"],
            }
          },
          layout: {
            padding: 0,
            margin: 0
          },
          responsive: true,
          maintainAspectRatio: true
        },
        colors: ["#36b8ba", "#510087"],
        datasetOverride: [],
        series: ["ES", "DEBERÍA SER"],
        labels: ["Flexibilidad", "Adhocrática", "Foco externo", "Mercado", "Consistencia", "Jerárquica", "Foco interno", "Clan"],
        data: [[null, 50, null, 52, null, 54, null, 56], [null, 60, null, 63, null, 66, null, 69],]
      }
      /* Datos hoy */
      dataparagrafica.data[0][1] = data.Adhocraciam_hoy.p;
      dataparagrafica.data[0][3] = data.Mercadodm_hoy.p;
      dataparagrafica.data[0][5] = data.Jerarquicam_hoy.p;
      dataparagrafica.data[0][7] = data.ClanM_hoy.p;

      /* Datos futuro */
      dataparagrafica.data[1][1] = data.Adhocraciam_futuro.p;
      dataparagrafica.data[1][3] = data.Jerarquicam_futuro.p;
      dataparagrafica.data[1][5] = data.Mercadodm_futuro.p;
      dataparagrafica.data[1][7] = data.ClanM_futuro.p;

      this.datagraficafrases =  dataparagrafica

    },
    graficaEntre(){
      let proceso = this.proceso.manualesEn
      let data

      if (proceso){
        data ={
          /* Datos hoy */
          Adhocraciam_hoy: {p: parseFloat(proceso.adhocraticaes)},
          Jerarquicam_hoy: {p: parseFloat(proceso.jerarquicaes)},
          Mercadodm_hoy: {p: parseFloat(proceso.mercadoes)},
          ClanM_hoy: {p: parseFloat(proceso.clanes)},
          /* Datos hoy */
          Adhocraciam_hoyG: {p: parseFloat(proceso.adhocraticaesg)},
          Jerarquicam_hoyG: {p: parseFloat(proceso.jerarquicaesg)},
          Mercadodm_hoyG: {p: parseFloat(proceso.mercadoesg)},
          ClanM_hoyG: {p: parseFloat(proceso.clanesg)},
          /* Datos futuro */
          Adhocraciam_futuro: {p: parseFloat(proceso.adhocraticads)},
          Jerarquicam_futuro: {p: parseFloat(proceso.jerarquicads)},
          Mercadodm_futuro: {p: parseFloat(proceso.mercadods)},
          ClanM_futuro: {p: parseFloat(proceso.clands)},
        }
      }else{
        data = {
          /* Datos hoy */
          Adhocraciam_hoy: {p: 0},
          Jerarquicam_hoy: {p: 0},
          Mercadodm_hoy: {p: 0},
          ClanM_hoy: {p: 0},
          Gerenciam_hoy: {p: 0},
          /* Datos hoy Gerencia */
          Adhocraciam_hoyG: {p: 0},
          Jerarquicam_hoyG: {p: 0},
          Mercadodm_hoyG: {p: 0},
          ClanM_hoyG: {p: 0},
          Gerenciam_hoyG: {p: 0},
          /* Datos futuro */
          Adhocraciam_futuro: {p: 0},
          Jerarquicam_futuro: {p: 0},
          Mercadodm_futuro: {p: 0},
          ClanM_futuro: {p: 0},
          Gerenciam_futuro: {p: 0},
        }
      }

      const dataparagrafica = {
        typeGraphic: "radar",
        options: {
          datasetFill: false,
          spanGaps: true,
          legend: {
            position: "top",
            labels: {
              "fontSize": 10,
            },
            display: true
          },
          scale: {
            ticks: {
              beginAtZero: true,
              fontColor: "#000000",
              /* backdropColor: 'white', */
              circular: true,
              min: 0,
              max: 100,
              stepSize: 25,
              z: 1
            },
            pointLabels: {
              fontSize: 13,
              fontColor: ["#bdbbbd","#c889aa","#bdbbbd","#e8913a","#bdbbbd","#674ea8","#bdbbbd","#3b79d8"],
            }
          },
          layout: {
            padding: 0,
            margin: 0
          },
          responsive: true,
          maintainAspectRatio: true
        },
        colors: ["#36b8ba", "#510087", "#cb8b12"],
        datasetOverride: [],
        series: ["ES", "DEBERÍA SER", "ES GERENCIA"],
        labels: ["Flexibilidad", "Adhocrática", "Foco externo", "Mercado", "Consistencia", "Jerárquica", "Foco interno", "Clan"],
        data: [[null, 50, null, 52, null, 54, null, 56], [null, 60, null, 63, null, 66, null, 69], [null, 60, null, 63, null, 66, null, 69]]
      }
      /* Datos hoy */
      dataparagrafica.data[0][1] = data.Adhocraciam_hoy.p;
      dataparagrafica.data[0][3] = data.Jerarquicam_hoy.p;
      dataparagrafica.data[0][5] = data.Mercadodm_hoy.p;
      dataparagrafica.data[0][7] = data.ClanM_hoy.p;

      /* Datos futuro */
      dataparagrafica.data[1][1] = data.Adhocraciam_futuro.p;
      dataparagrafica.data[1][3] = data.Jerarquicam_futuro.p;
      dataparagrafica.data[1][5] = data.Mercadodm_futuro.p;
      dataparagrafica.data[1][7] = data.ClanM_futuro.p;

      /* Datos hoy Gerencia */
      dataparagrafica.data[2][1] = data.Adhocraciam_hoyG.p;
      dataparagrafica.data[2][3] = data.Jerarquicam_hoyG.p;
      dataparagrafica.data[2][5] = data.Mercadodm_hoyG.p;
      dataparagrafica.data[2][7] = data.ClanM_hoyG.p;

      this.datagraficaEntre =  dataparagrafica

    },
    graficaDimen(dataDimen){
      const _this = this
      let data ={
        /* Datos hoy */
        Adhocraciam_hoy: {
          p: parseFloat(dataDimen.hoy[_this.dimensiones.Adhocraciam_hoy.list.filter(k => dataDimen.hoy[k])[0]])
        },
        Jerarquicam_hoy: {
          p: parseFloat(dataDimen.hoy[_this.dimensiones.Jerarquicam_hoy.list.filter(k => dataDimen.hoy[k])[0]])
        },
        Mercadodm_hoy: {
          p: parseFloat(dataDimen.hoy[_this.dimensiones.Mercadodm_hoy.list.filter(k => dataDimen.hoy[k])[0]])
        },
        ClanM_hoy: {
          p: parseFloat(dataDimen.hoy[_this.dimensiones.ClanM_hoy.list.filter(k => dataDimen.hoy[k])[0]])
        },

        /* Datos futuro */
        Adhocraciam_futuro: {
          p: parseFloat(dataDimen.futuro[_this.dimensiones.Adhocraciam_futuro.list.filter(k => dataDimen.futuro[k])[0]])
        },
        Jerarquicam_futuro: {
          p: parseFloat(dataDimen.futuro[_this.dimensiones.Jerarquicam_futuro.list.filter(k => dataDimen.futuro[k])[0]])
        },
        Mercadodm_futuro: {
          p: parseFloat(dataDimen.futuro[_this.dimensiones.Mercadodm_futuro.list.filter(k => dataDimen.futuro[k])[0]])
        },
        ClanM_futuro: {
          p: parseFloat(dataDimen.futuro[_this.dimensiones.ClanM_futuro.list.filter(k => dataDimen.futuro[k])[0]])
        },
      }

      _this.dimensiones.Adhocraciam_hoy.list.filter(function (k){
        return dataDimen.hoy[k]
      })

      const dataparagrafica = {
        typeGraphic: "radar",
        options: {
          datasetFill: false,
          spanGaps: true,
          legend: {
            position: "top",
            labels: {
              "fontSize": 10,
            },
            display: true
          },
          scale: {
            ticks: {
              beginAtZero: true,
              fontColor: "#000000",
              /* backdropColor: 'white', */
              circular: true,
              min: 0,
              max: 100,
              stepSize: 25,
              z: 1
            },
            pointLabels: {
              fontSize: 13,
              fontColor: ["#bdbbbd","#c889aa","#bdbbbd","#e8913a","#bdbbbd","#674ea8","#bdbbbd","#3b79d8"],
            }
          },
          layout: {
            padding: 0,
            margin: 0
          },
          responsive: true,
          maintainAspectRatio: true
        },
        colors: ["#36b8ba", "#510087"],
        datasetOverride: [],
        series: ["ES", "DEBERÍA SER"],
        labels: ["Flexibilidad", "Adhocrática", "Foco externo", "Mercado", "Consistencia", "Jerárquica", "Foco interno", "Clan"],
        data: [[null, 50, null, 52, null, 54, null, 56], [null, 60, null, 63, null, 66, null, 69],]
      }
      /* Datos hoy */
      dataparagrafica.data[0][1] = data.Adhocraciam_hoy.p;
      dataparagrafica.data[0][3] = data.Mercadodm_hoy.p;
      dataparagrafica.data[0][5] = data.Jerarquicam_hoy.p;
      dataparagrafica.data[0][7] = data.ClanM_hoy.p;

      /* Datos futuro */
      dataparagrafica.data[1][1] = data.Adhocraciam_futuro.p;
      dataparagrafica.data[1][3] = data.Mercadodm_futuro.p;
      dataparagrafica.data[1][5] = data.Jerarquicam_futuro.p;
      dataparagrafica.data[1][7] = data.ClanM_futuro.p;

      return dataparagrafica

    },
    createdGraphBullet(name, hoy, futuro, color) {
      try {
        if (this.summaryTotal.total) {
          const data = this.summaryTotal.total;
          const gap = (data[hoy].p - data[futuro].p).toFixed(1);
          let colorD = '';
          let range = ''
          let showTicks = false

          if (name === "Clan") {
            showTicks = true
          }

          if(this.absvalor(gap) < 5){
            // 0- 5 : baja
            colorD = this.rangos.baja
            range = 'Baja'
          }
          else if(this.absvalor(gap) >= 5 && gap < 10){
            // 5- 10: media
            colorD = this.rangos.media
            range = 'Media'
          }
          else if(this.absvalor(gap) >= 10 && gap < 20){
            // 10 - 20: alta
            colorD = this.rangos.alta
            range = 'Alta'
          }
          else if(this.absvalor(gap) >= 20){
            // 20>: muy alta
            colorD = this.rangos.muyAlta
            range = 'Muy alta'
          }

          let dataGraph = {
            data: [
              {
                type: "indicator",
                mode: "gauge+delta", /* number+gauge+delta */
                title: {
                  text:
                      `<b>${name}</b>`,
                  font: { size: 14, color }
                },
                value: data[hoy].p,
                domain: { x: [0, 1], y: [0, 1] },
                delta: {
                  reference: data[futuro].p,
                  font: { size: 14 },
                  decreasing: {
                    color: colorD,
                  },
                  increasing:{
                    color: colorD,
                  },
                  suffix: ` <span style="font-size: 13px; font-weight: bold">${range}</span>`
                  // "prefix": "$", "suffix": "m"
                },
                gauge: {
                  shape: "bullet",
                  axis: {range: [0, 100], showticklabels: showTicks},
                  threshold: {
                    line: {color: "#510087", width: 3},
                    thickness: 1,
                    value: data[futuro].p,
                  },
                  steps: [
                      {range: [0, 25], color: '#F0F0F0', thickness: 0.7,},
                      {range: [25, 50], color: '#F0F0F0', thickness: 0.7,},
                      {range: [50, 75], color: '#F0F0F0', thickness: 0.7,},
                      {range: [75, 100], color: '#F0F0F0', thickness: 0.7,},
                  ],
                  bgcolor: "white",
                  bar: { color: "#36b8ba", thickness: 0.2 },
                  bordercolor: "white",
                },
                target: gap, // Para mostrar el dato anterior
                nameValue: 'Es',
                nameLast: 'Deberia ser'
              }
            ],
            options: {
              config: {
                responsive: true,
                displayModeBar: false
              },
              layout: {
                weight: 300,
                height: 60,
                margin: {
                  l: 110,
                  r: 15,
                  b: 20,
                  t: 0,
                  pad: 1
                },
              }
            }
          }
          return dataGraph
        }
      } catch (err) {
        console.log(err)
      }
    },
    // Utilities of graphics
    tooltipCustom(){
      const customTooltip = {
        intersect: false,
        enabled: false,
        mode: 'index',
        position: 'nearest',
        custom: function (tooltipModel) {
          // Tooltip Element
          var tooltipEl = document.getElementById('tooltipCustom');

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'tooltipCustom';
            tooltipEl.innerHTML = '<table></table>';
            document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add('no-transform');
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            let titleLines = ['Datos'];
            let bodyLines = tooltipModel.body.map(getBody);

            bodyLines.push(`Deberia: ${this._chart.options.lineAtIndex}`);

            let innerHtml = '<thead>';

            titleLines.forEach(function(title) {
              innerHtml += '<tr><th style="color: white; text-align: center">' + title + '</th></tr>';
            });
            innerHtml += '</thead><tbody>';

            bodyLines.forEach(function(body, i) {
              let style = 'background: white';
              style += '; border-color: black';
              style += '; border-width: 2px';
              let span = '<span style="' + style + '"></span>';
              innerHtml += '<tr><td>' + span + body + '</td></tr>';
            });
            innerHtml += '</tbody>';

            let tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
          }

          // `this` will be the overall tooltip
          const position = this._chart.canvas.getBoundingClientRect();

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
          tooltipEl.style.pointerEvents = 'none';
          tooltipEl.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
          tooltipEl.style.borderRadius = "3px";
          tooltipEl.style.padding = "10px";
          tooltipEl.style.webkitTransition = "all 0.1s ease";
          tooltipEl.style.transition = "all 0.1s ease";
          tooltipEl.style.color = "white";
        }
      };

      return customTooltip
    },
    // Data
    async findsummary() {
      try {
        const query = {
          filters: this.selected.filters,
          proceso: this.proceso._id,
        };
        let result = {}
        if (this.$route.params.id){
          result = await apiServices.post(`/traecalculoculturaPb`, query);
        }else {
          result = await apiServices.post(`/traecalculocultura`, query);
        }

        if (result.data) {
          let filters = {list: []};
          /* Se guardan los grupos y subgrupos de cada grupo */
          for (let index in result.data.grupos) {
            const dato = result.data.grupos[index];
            filters.list.push(dato.nombre);
            filters[dato.nombre] =
                result.data.calculos[dato.nombre].subgrupos;
          }

          /* this.filtersselected = JSON.parse(
              JSON.stringify(this.selected.filters)
          ); */

          /* Se organiza la data */
          let dataCult = []
          let valMayor = []
          for (let index in result.data.calculos.grupos) {
            let group = result.data.calculos.grupos[index]
            let g = {}
            for (let index2 in result.data.calculos[group]) {
              if (index2 !== "subgrupos") {
                g = result.data.calculos[group][index2]
                g.grupo = group
                g.nombre = index2
                g.cambio = 0
                dataCult.push(g)

                /* Datos para calcular el dato mayor */
                valMayor.push((g.Adhocraciam_hoy.p).toFixed(1))
                valMayor.push((g.Jerarquicam_hoy.p).toFixed(1))
                valMayor.push((g.Mercadodm_hoy.p).toFixed(1))
                valMayor.push((g.ClanM_hoy.p).toFixed(1))

                valMayor.push((g.Adhocraciam_futuro.p).toFixed(1))
                valMayor.push((g.Jerarquicam_futuro.p).toFixed(1))
                valMayor.push((g.Mercadodm_futuro.p).toFixed(1))
                valMayor.push((g.ClanM_futuro.p).toFixed(1))
              }
            }
          }

          this.filters = filters
          this.summary = dataCult;
          this.valMayor = Math.max(...valMayor)
          console.log(dataCult)
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Table Groups
    setFilterTable(newFilter){
      if(newFilter.length){
        try {
          this.selected.filters = {[newFilter[0].grupo]: [newFilter[0].nombre]}

          this.$store.dispatch("notify", {
            message: `Filtro aplicado al tablero`,
            type: "is-link",
          });
        } catch (e) {
          this.selected.filters = {};
          this.$store.dispatch("notify", {
            message: `Error al aplicar el filtro al tablero`,
            type: "is-danger",
          });
        }
      }else{
        this.selected.filters = {}
        this.$store.dispatch("notify", {
          message: `Filtro eliminado correctamente`,
          type: "is-link",
        });
      }
    },
    deselectFilter(){
      this.$refs.tableCult.deselect();
    },
    // Change views
    changeShowMoreMytho(){
      this.showMoreMytho ? this.showMoreMytho = false : this.showMoreMytho = true
    },
    // Helpers
    getFilterGroup(f){
      let data = Object.keys(f)
      if(data.length > 0){
        return data[0];
      }
      return null
    },
    getFilterSubGroup(f){

      let data = Object.keys(f)
      if(data.length > 0){
        return f[data[0]][0];
      }
      return null
    },
    absvalor(valor) {
      if (valor < 0) {
        return valor * -1
      } else {
        return valor
      }
    }
},
  created() {
    if (this.idtoken){
      this.findsummary()
    }},
  watch: {
    'selected.filters'(nv) {
      this.$emit('filter', nv)
      console.log(this.selected.filters)
    },
    summaryTotal(nv){
      if (nv){
        let dataTotal = nv.total
        this.graficar(dataTotal)
        this.graficaFrases()
        this.graficaEntre()
      }
    },
  },
  components: {
    yGraph,
    bGraph,
    tableGroupsResult,
  }
}
</script>

<style scoped lang="scss">
.panel-block {
  border: white 1px solid !important;
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.81);
}

.bg-baja{
  background-color: #225ea8;
  border: solid 0px white !important;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}
.bg-media{
  background-color: #4cb6c4;
  border: solid 0px white !important;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}
.bg-alta{
  background-color: #a1dab4;
  color: white;
  border: solid 0px white !important;
  padding-left: 10px;
  padding-right: 10px;
}
.bg-muyAlta{
  background-color: #fcdd82;
  border: solid 0px white !important;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}

.is-blue{
  background-color: #a8c2ef !important;
  color: white !important;
}

</style>



// WEBPACK FOOTER //
// src/components/cultura/ResulParte1.vue